module.exports = __webpack_public_path__ + "img/3A等级证书_06.7d562ece.jpg";